import { get } from 'libs/api';
import { useGlobalStore } from 'libs/lead-capture-form/state/globalStore';
import { ENTITY_TYPE } from 'libs/lead-capture-form/utils/constants';
import { getEntityCookiePassword } from 'libs/lead-capture-form/utils/helper';
import { useCallback, useEffect, useState } from 'react';

export const useRLEWithLead = () => {
  const leadId = useGlobalStore.getState().cookie;
  const eventId = useGlobalStore.getState().apiEventId;
  const [rleData, setRleData] = useState<any>({});
  const [loading, setLoading] = useState(true);

  const fetchRLE = useCallback(async () => {
    setLoading(true);
    if (eventId && leadId) {
      const entityPassword = getEntityCookiePassword(eventId, ENTITY_TYPE.EVENT);
      const finalResponse = await get(
        `/live_events/${eventId}?fields=clip_to_play&lead_uuid=${leadId}&password=${entityPassword}`,
      );
      setRleData(finalResponse);
    }
    setLoading(false);
  }, [eventId, leadId]);

  useEffect(() => {
    fetchRLE();
  }, [eventId, leadId, fetchRLE]);
  return { clipToPlay: rleData?.clipToPlay, loading };
};
